
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/firestore";
import "firebase/compat/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
	apiKey: "AIzaSyA7MzfevxVRjb2FwWuQmcfQKeQkspSHuqs",
	authDomain: "her-bloom-b5570.firebaseapp.com",
	projectId: "her-bloom-b5570",
	storageBucket: "her-bloom-b5570.firebasestorage.app",
	messagingSenderId: "488310991046",
	appId: "1:488310991046:web:40cab092436dd89ced8fc7"
  };
// Initialize Firebase
let app;

if (firebase.apps.length === 0) {
	app = firebase.initializeApp(firebaseConfig);
} else {
	app = firebase.app();
}

const db = app.firestore();
const auth = firebase.auth();
const storage = app.storage();

export { db, auth, storage };
